//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapMutations } from "vuex";
import RoundMvp from '../round-mvp'
import GlitchImage from '../glitch-image'
import CrashNotifications from '../crash-notifications'
import { Empty } from 'element-ui';

export default {
    name: 'CrashGameUI',
    props: ['gameId', 'gameState', 'tick', 'gameCountDownData', 'crashPoint', 'allBetAmount', 'playersCount', 'spectateTarget', 'crashOutPlayers', 'mvpList'],
    components: {
        GlitchImage,
        RoundMvp,
        CrashNotifications
    },
    data() {
        return {
            emptyItem: require('../../assets/gun_1.png'),
            GAME_STATES: {
                NotStarted: 'NotStarted',
                Starting: 'Starting',
                InProgress: 'InProgress',
                Over: 'Over',
                Blocking: 'Blocking',
                Refunded: 'Refunded',
                Crash: 'Crash',
            }
        }
    },
    mounted() {

    },
    beforeDestroy() {
    },
    computed: {
        		...mapState(["user"]),
        game() {
            return { id: this.gameId, status: this.gameState }
        },
        currentLoot() {
            // 如果数据为空，或者不是对象，返回默认兜底对象
            if (!this.spectateTarget.player.lootItems 
            || typeof this.spectateTarget.player.lootItems !== 'object' 
            || Object.keys(this.spectateTarget.player.lootItems).length === 0 ) {
                return { src: this.emptyItem, nextSrc: this.emptyItem, name: '', multiplier: 1 };
            }

            try {
                // 1. 将 key (倍率字符串) 转为浮点数并组合成数组，按倍率从小到大排序
                const sortedItems = Object.keys(this.spectateTarget.player.lootItems )
                    .map(multiplierStr => ({
                        multiplier: parseFloat(multiplierStr),
                        ...this.spectateTarget.player.lootItems[multiplierStr]
                    }))
                    .sort((a, b) => a.multiplier - b.multiplier);

                if (sortedItems.length === 0) {
                    return { src: '', nextSrc: '', name: '', multiplier: 1 };
                }

                const rewardItem  = this.spectateTarget.player.rewardItem;
                if (rewardItem) {
                    return { src: rewardItem.itemPic, nextSrc: rewardItem.itemPic, name: rewardItem.name , multiplier: 1 };
                }

                const currentTick = Number(this.tick) || 1;

                // 2. 遍历匹配当前 tick 所在的区间
                for (let i = 0; i < sortedItems.length; i++) {
                    const item = sortedItems[i];
                    const nextItem = sortedItems[i + 1];

                    if (!nextItem || currentTick < nextItem.multiplier) {
                        return {
                            src: item.itemPic || '',
                            nextSrc: nextItem ? (nextItem.itemPic || '') : (item.itemPic || ''),
                            name: item.name || '',
                            multiplier: item.multiplier
                        };
                    }
                }

                // 3. 兜底返回最后一项
                const fallback = sortedItems[sortedItems.length - 1];
                return {
                    src: fallback.itemPic || '',
                    nextSrc: fallback.itemPic || '',
                    name: fallback.name || '',
                    multiplier: fallback.multiplier
                };
            } catch (e) {
                console.error("currentLoot error:", e);
                return { src: this.emptyItem, nextSrc: this.emptyItem, name: '', multiplier: 1 };
            }
        }
    },
    methods: {
    }
}
